import { Component } from '@verndale/core';
import { breakpoints, customEvents } from '../helpers/constants';
import anime from 'animejs';

class PrimaryNavigationMobile extends Component {
  setupDefaults() {
    this.isNavigationOpen = false;
    this.isChildListOpen= false;
    this.dom = {
      html: document.querySelector('html'),
      innerContainer: this.el.querySelector('.primary-navigation-mobile__inner'),
      toggleTrigger: document.querySelector('.header__primary-navigation__trigger'),
      childListOpenTriggers: [...this.el.querySelectorAll('.primary-navigation-mobile__child-list-trigger, .primary-navigation-mobile__main-link > button')],
      childListCloseTriggers: [...this.el.querySelectorAll('.primary-navigation-mobile__child-list-close-trigger')]
    };
  }

  addListeners() {
    //Open-Close navigation
    this.dom.toggleTrigger.addEventListener('click', e => this.toggleMobileNavigation(e))
    // Open item child list
    this.dom.childListOpenTriggers.forEach(openTrigger => {
      openTrigger.addEventListener('click', e => this.toggleChildList(e));
    })
    // Close item child list
    this.dom.childListCloseTriggers.forEach(closeTrigger => {
      closeTrigger.addEventListener('click', e => this.toggleChildList(e));
    })
    window.addEventListener(customEvents.closeMobilePrimaryNavTrigger, () => {
      this.isNavigationOpen = true;
      this.toggleMobileNavigation();
    })
  }

  toggleMobileNavigation(e) {
    if (window.innerWidth >= breakpoints.tabletLandscape) return;
    this.isNavigationOpen = !this.isNavigationOpen;
    if (this.isNavigationOpen) {
      this.dom.html.style.overflowY = 'hidden'
      this.dom.toggleTrigger.classList.add('is-open');
      this.el.classList.add('active');
      this.el.setAttribute('aria-hidden', 'false');
      this.el.setAttribute('tabindex', '0');
      const closeEvent = new CustomEvent(customEvents.closeWeatherWidgetTrigger);
      window.dispatchEvent(closeEvent);
    }
    const timeline = anime.timeline({
      easing: 'easeInOutQuad',
      direction: this.isNavigationOpen ? 'normal' : 'reverse',
      ...!this.isNavigationOpen && {
        complete: () => {
          this.dom.html.style.overflowY = 'auto'
          this.dom.toggleTrigger.classList.remove('is-open');
          this.el.classList.remove('active');
          this.el.setAttribute('aria-hidden', 'true');
          this.el.setAttribute('tabindex', '-1');
        }
      }
    });
    timeline.add({
      targets: this.dom.innerContainer,
      translateY: ['100%', '0%'],
      duration: 300
    }, 0);
  }

  toggleChildList(e) {
    e.stopPropagation();
    this.isChildListOpen = !this.isChildListOpen;
    const parent = e.currentTarget.closest('.primary-navigation-mobile__item');
    const childListContainer = parent.querySelector('.primary-navigation-mobile__child-container');
    this.el.classList.toggle('child-list-active');
    childListContainer.classList.toggle('active');
    childListContainer.setAttribute('aria-hidden', this.isChildListOpen ? 'false' : 'true');
    childListContainer.setAttribute('tabindex', this.isChildListOpen ? '0' : '-1');
  }
}

export default PrimaryNavigationMobile;
